import type { NextPage } from "next";

const Home: NextPage = () => {
  return <div />;
};

export default Home;
